import moment from "moment";

export const STATE_TINTS = {
  RUNNING: {label: "Running", bg: "#D9F2E4", color: "#1E7F52", dot: "#34B27B"},
  SCHEDULED: {label: "Scheduled", bg: "rgba(132, 145, 247, 0.2)", color: "#4B55C9", dot: "#8491F7"},
  FINISHED: {label: "Finished", bg: "#D6E8F8", color: "#2D6FB0", dot: "#5B9BD5"},
};

export const campaignStart = (campaign) => moment(campaign.startDate).startOf("day");
export const campaignEnd = (campaign) => moment(campaign.endDate).startOf("day");

export const campaignState = (campaign) => {
  const today = moment().startOf("day");
  if (today.isBefore(campaignStart(campaign), "day")) return "SCHEDULED";
  if (today.isAfter(campaignEnd(campaign), "day")) return "FINISHED";
  return "RUNNING";
};

export const campaignRunsOn = (campaign, day) =>
  !day.isBefore(campaignStart(campaign), "day") && !day.isAfter(campaignEnd(campaign), "day");

export const monthWeeks = (month) => {
  const first = month.clone().startOf("month").startOf("isoWeek");
  const last = month.clone().endOf("month").endOf("isoWeek");
  const weeks = [];
  const cursor = first.clone();
  while (cursor.isBefore(last)) {
    weeks.push(Array.from({length: 7}, (_, index) => cursor.clone().add(index, "days")));
    cursor.add(7, "days");
  }
  return weeks;
};

const CAMPAIGN_COLORS = [
  {bg: "#E8EAFE", color: "#4B55C9", dot: "#8491F7"},
  {bg: "#FFE3EC", color: "#B8336E", dot: "#F27BA5"},
  {bg: "#FFE8D9", color: "#AB5420", dot: "#F5A272"},
  {bg: "#D9F5E7", color: "#1B7A4E", dot: "#4CC38A"},
  {bg: "#DCEBFB", color: "#2A68AB", dot: "#5DA9E9"},
  {bg: "#D5F2F5", color: "#13727E", dot: "#3FBFC9"},
  {bg: "#F4E1F7", color: "#8E3AA0", dot: "#C77DD4"},
  {bg: "#FFE1DE", color: "#B23F36", dot: "#F28B82"},
];

export const CAMPAIGN_PALETTE = CAMPAIGN_COLORS.map(item => item.dot.toLowerCase());

export const DEFAULT_CAMPAIGN_COLOR = CAMPAIGN_COLORS[0];

export const isHexColor = (value) => /^#[0-9a-f]{6}$/i.test(String(value || ""));

const fromHex = (hex) => {
  const value = parseInt(hex.slice(1), 16);
  return [(value >> 16) & 255, (value >> 8) & 255, value & 255];
};

const shade = (hex, amount) => {
  const [r, g, b] = fromHex(hex).map(channel => Math.round(channel * (1 - amount)));
  return "#" + [r, g, b].map(channel => channel.toString(16).padStart(2, "0")).join("");
};

export const campaignColor = (campaign) => {
  if (isHexColor(campaign.color)) {
    return {bg: campaign.color + "2E", color: shade(campaign.color, 0.45), dot: campaign.color};
  }
  return DEFAULT_CAMPAIGN_COLOR;
};
